import { __decorate, __metadata } from "tslib";
import { BaseMessage, Field } from '@cbbt/lib-interface';
import { ALPHA_CHAR_PATTERN, EMPTY_TRAIL_LEADING_SPACE_PATTERN, } from '../utils/regex.js';
export class Address extends BaseMessage {
    houseNumber;
    houseName;
    flatNumber;
    street;
    district;
    townCity;
    county;
    postCode;
    countryOfAddress;
    countryOfBirth;
}
__decorate([
    Field.string({
        required: true,
        description: 'AddressLine1',
        maxLength: 60,
        pattern: EMPTY_TRAIL_LEADING_SPACE_PATTERN,
    }),
    __metadata("design:type", String)
], Address.prototype, "houseNumber", void 0);
__decorate([
    Field.string({
        required: true,
        description: 'AddressLine2',
        maxLength: 60,
        pattern: EMPTY_TRAIL_LEADING_SPACE_PATTERN,
    }),
    __metadata("design:type", String)
], Address.prototype, "houseName", void 0);
__decorate([
    Field.string({
        description: 'AddressLine3',
        maxLength: 60,
        pattern: EMPTY_TRAIL_LEADING_SPACE_PATTERN,
    }),
    __metadata("design:type", String)
], Address.prototype, "flatNumber", void 0);
__decorate([
    Field.string({
        description: 'AddressLine4',
        maxLength: 60,
        pattern: EMPTY_TRAIL_LEADING_SPACE_PATTERN,
    }),
    __metadata("design:type", String)
], Address.prototype, "street", void 0);
__decorate([
    Field.string({
        description: 'AddressLine5',
        maxLength: 60,
        pattern: EMPTY_TRAIL_LEADING_SPACE_PATTERN,
    }),
    __metadata("design:type", String)
], Address.prototype, "district", void 0);
__decorate([
    Field.string({
        description: 'AddressLine6',
        maxLength: 60,
        pattern: EMPTY_TRAIL_LEADING_SPACE_PATTERN,
    }),
    __metadata("design:type", String)
], Address.prototype, "townCity", void 0);
__decorate([
    Field.string({
        description: 'AddressLine7',
        maxLength: 60,
        pattern: EMPTY_TRAIL_LEADING_SPACE_PATTERN,
    }),
    __metadata("design:type", String)
], Address.prototype, "county", void 0);
__decorate([
    Field.string({
        required: true,
        description: 'Post code',
        maxLength: 8,
        pattern: '^([A-Z][A-HJ-Y]?\\d[\\dA-Z]? ?\\d[A-Z]{2}|GIR ?0A{2})$',
    }),
    __metadata("design:type", String)
], Address.prototype, "postCode", void 0);
__decorate([
    Field.string({
        required: true,
        description: 'Country',
        pattern: ALPHA_CHAR_PATTERN,
    }),
    __metadata("design:type", String)
], Address.prototype, "countryOfAddress", void 0);
__decorate([
    Field.string({
        required: false,
        description: 'Country code',
        maxLength: 3,
        pattern: EMPTY_TRAIL_LEADING_SPACE_PATTERN,
    }),
    __metadata("design:type", String)
], Address.prototype, "countryOfBirth", void 0);
//# sourceMappingURL=Address.js.map